module.exports = require("./fr-MA.js");